import { QrcodeIcon } from '@zep-us/zus-icons';
import { useTranslation } from 'next-i18next';
import { PenPaperIcon } from '@/icons';
import type { Folder } from '@/shared/features/quiz-folder';
import { Button, IconButton } from '@/ui_v3';
import { useFolderCta } from '../hooks/useFolderCta';

/**
 * 모바일 하단 고정 CTA. 소유자에게만 그리고, 데스크톱의 `FolderCtaPanel` 과 같은 판정(`useFolderCta`)을 쓴다.
 *
 * 주 버튼 라벨은 `입장하기` 로 짧고, `수정` 은 라벨 없는 아이콘 버튼이다.
 */
export const FolderMobileCta = ({
  folder
}: {
  folder: Folder;
}) => {
  const {
    t
  } = useTranslation(['common']);
  const {
    showPayPlan,
    playIcon,
    isPlayDisabled,
    startPlay,
    showShareButton,
    shareEntry,
    openPaywall,
    goEdit
  } = useFolderCta(folder);
  return <div className={'flex w-full items-center gap-2xs'} data-sentry-component="FolderMobileCta" data-sentry-source-file="FolderMobileCta.tsx">
      {/* 데스크톱과 같은 우선순위 — `플랜 결제` 가 있으면 그쪽이 주 버튼이고 재생은 보조가 된다. */}
      {showPayPlan && <Button variant={'contained'} intent={'gradient'} size={'md'} className={'flex-1'} onClick={openPaywall}>
          {t('common:detail.payPlan')}
        </Button>}
      <Button variant={showPayPlan ? 'outlined' : 'contained'} intent={showPayPlan ? 'alternative' : 'gradient'} size={'md'} className={'flex-1'} disabled={isPlayDisabled} onClick={startPlay} leftSlot={playIcon} data-sentry-element="Button" data-sentry-source-file="FolderMobileCta.tsx">
        {t('common:folder.detail.play.enterShort')}
      </Button>
      {showShareButton && <IconButton variant={'outlined'} intent={'neutral'} size={'md'} aria-label={t('common:detail.cta.share')} onClick={shareEntry}>
          <QrcodeIcon size={'xs'} />
        </IconButton>}
      <IconButton variant={'outlined'} intent={'neutral'} size={'md'} aria-label={t('common:global.edit.button')} onClick={goEdit} data-sentry-element="IconButton" data-sentry-source-file="FolderMobileCta.tsx">
        <PenPaperIcon size={'xs'} data-sentry-element="PenPaperIcon" data-sentry-source-file="FolderMobileCta.tsx" />
      </IconButton>
    </div>;
};